import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

interface Props {
  email: string;
  password: string;
}

const loginMutation = () => useMutation({
  mutationKey: ['resetPassword'],
  mutationFn: (body: Props) => agent.getClient(false).post('/auth/email/login', body),
  onSuccess: () => { },
});

export default loginMutation;
